<template>
    <div class="pl-1">
        <template v-if="cities_data != null && cities_data.length > 1">
            <span 
                v-for="city in cities_data"
                :key="city.title"
                :class="'badge badge-' + $root.network"
            >{{ city['title'] }}</span>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        cities_list: {
            type: Array,
            required: false,
        },

        cities: {
            type: [String, Number],
            required: false,
        },
    },

    data() {
        return {
            ssr: true,
            cities_data: []
        }
    },

    mounted() {
        window.events.$on('list.cities', event => {
            this.cities_data = event;
            this.ssr = false;
        })

        if (this.cities && this.cities_list) {
            let cities = this.cities.split('|')

            this.cities_list.forEach(city => {
                if (cities.includes(String(city.id))) {
                    this.cities_data.push(city)
                }
            })
        }
    }
}
</script>